import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { DialogService } from '../../../_services/dialog.service';
import { Merchant } from '../../../_models/fundraising/Merchant';
import { MerchantService } from '../../../_services/fundraising/merchant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FundraisingAccountLinkModalComponent } from '../fundraising-account-link-modal.component';
import { UserService } from '../../../_services/user.service';

@Component({
  selector: 'app-merchant-management',
  templateUrl: './merchant-management.component.html',
  styleUrls: ['./merchant-management.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class MerchantManagementComponent implements OnInit {

  searchText: string;
  merchants: Merchant[] = [];
  displayItems: Merchant[] = [];

  private bsModalRef: BsModalRef;

  constructor(
    private merchantService: MerchantService,
    private dialogService: DialogService,
    public viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getMerchants();
  }

  public createNew() {
    this.router.navigate([`create`], {relativeTo: this.route});
  }

  public delete(merchant: Merchant) {

    let deleteMessage = 'Are you sure you want to delete this merchant?';
    if (!merchant.active) {
      deleteMessage = 'This account has already been set to inactive, this action will PERMANENTLY delete this merchant. Are you sure you want to continue?'
    } 

    this.dialogService.confirm('Confirm Delete', deleteMessage, this.viewRef)
      .then(result => {
        if (result) {
          if (merchant.verified) {
            this.dialogService.confirm(
              'Confirm Delete of Verfied Merchant', 
              'This merchant has a verfied Stripe account, and this action will PERMANENTLY delete this account from Stripe. Are you REALLY sure want to delete this merchant?', 
              this.viewRef)
            .then(result => {
              if (result) {
                this.deleteMerchant(merchant.merchantId);
              }
            });
          } else {
            this.deleteMerchant(merchant.merchantId);
          } 
        }
    });
  }

  public edit(merchant: Merchant) {
    this.router.navigate([`create/${merchant.merchantId}`], {relativeTo: this.route});
  }

  public openAccountLinkModal(merchantId: number) {
    const modalConfig = {
        backdrop: true,
        ignoreBackdropClick: true
    };

    const initialState = {
      accountId: merchantId,
      accountType: 'merchant'
    };

    this.bsModalRef = this.modalService
      .show(
          FundraisingAccountLinkModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-sm', initialState })
      );

    this.bsModalRef.content.hasError.subscribe(
        value => {
            if (value) {
              this.dialogService.alert('Error', `Unable to create account links`, this.viewRef);
            } else {
                this.getMerchants();
            }
      });
  }


  public resendPortalOnboardingUrl(merchant: Merchant) {
    this.dialogService.confirm(
      'Confirm Resend Portal Invite', 
      'Are you sure you want to resend the portal onboarding invite?', 
      this.viewRef)
    .then(result => {
      if (result) {
        this.spinner.show();
        this.merchantService.resendPortalOnboardingUrl(merchant.merchantId)
        .subscribe(
          () => {
            this.spinner.hide();
          },
          error => {
            this.spinner.hide();
            this.dialogService.alert('Error', `Unable to resend portal invite. Message: ${error.error}`, this.viewRef);
          }
        );
      }
    });
  }

  public getMerchants() {
    this.spinner.show();
    this.merchantService.getAll().subscribe(
      data => {
        this.merchants = data;
        this.displayItems = data;
      },
      error => {
        this.dialogService.alert('Error', `Unable to get merchants. ${error.error}`, this.viewRef);
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  public search() {
    if (!this.searchText) {
      return;
    }

    const search = this.searchText.toLowerCase();
    this.displayItems = this.merchants.filter(d =>
      (d.name ? d.name.toLowerCase().indexOf(search) !== -1 : false) ||
      (d.email ? d.email.toLowerCase().indexOf(search) !== -1 : false) ||
      (d.createdBy ? d.createdBy.toLowerCase().indexOf(search) !== -1 : false) ||
      (d.modifiedBy ? d.modifiedBy.toLowerCase().indexOf(search) !== -1 : false) );
  }
   
  private deleteMerchant(merchantId: number) {
    this.spinner.show();
      this.merchantService.delete(merchantId)
      .subscribe(
        () => {
          this.spinner.hide();
          this.getMerchants();
        },
        error => {
          this.spinner.hide();
          this.dialogService.alert('Error', `Unable to delete merchant. Message: ${error.error}`, this.viewRef);
        }
      ); 
  }

}
